<template>
  <div>
    <v-list>
      <div
        v-if="
          proposal != null &&
            proposal.visited != null &&
            proposal.visited.report
        "
        class="ml-3 mr-3 py-1 overflow-hidden"
      >
        <v-list-tile-title>Compte-rendu de visite</v-list-tile-title>
        <p class="description">{{ proposal.visited.report }}</p>
      </div>
      <v-divider
        v-if="
          proposal != null &&
            proposal.visited != null &&
            proposal.visited.report
        "
      ></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Adresse</v-list-tile-title>
          <v-list-tile-sub-title>{{ host.address }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile v-if="proposal != null" class="mb-1">
        <v-list-tile-content>
          <v-list-tile-title>Distance du travail</v-list-tile-title>
          <v-list-tile-sub-title>
            <v-layout row>
              <v-flex xs4 lg4>
                <v-icon>directions_car</v-icon>
                {{
                  proposal.distanceCar
                    ? (proposal.distanceCar / 60).toFixed(0)
                    : "??"
                }}
                min</v-flex
              >
              <v-flex xs4 lg4>
                <v-icon>directions_subway</v-icon>
                {{
                  proposal.distanceTransport
                    ? (proposal.distanceTransport / 60).toFixed(0)
                    : "??"
                }}
                min</v-flex
              >
              <v-flex xs4 lg4>
                <v-icon>directions_run</v-icon>
                {{
                  proposal.distanceWalk
                    ? (proposal.distanceWalk / 60).toFixed(0)
                    : "??"
                }}
                min</v-flex
              >
            </v-layout>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="proposal != null"></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Surface</v-list-tile-title>
          <v-list-tile-sub-title>{{ host.carrez }} m</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Pièces</v-list-tile-title>
          <v-list-tile-sub-title
            >{{ host.numberOfRoom }} pièce{{
              host.numberOfRoom > 1 ? "s" : ""
            }}</v-list-tile-sub-title
          >
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Loyer</v-list-tile-title>
          <v-list-tile-sub-title>{{ host.price }} €</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Date de disponibilité</v-list-tile-title>
          <v-list-tile-sub-title v-if="host.dateAvailable">{{
            host.dateAvailable | date
          }}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-else>
            Inconnue
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
    <div class="description ml-3 mr-3 py-1 pb-2 overflow-hidden">
      {{ host.description || "Pas de description" }}
    </div>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Annonce d'origine</v-list-tile-title>
          <v-list-tile-sub-title>{{ host.externalId }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { fetchHil } from "../../utils";

export default {
  name: "HostDetails",
  props: ["host", "proposal"]
};
</script>

<style scoped>
.description {
  color: grey;
  margin: 0;
}
</style>
